export enum CustomPropertyType {
    CONTACT = 'contacts',
    ORGANISATION = 'organisations',
    TASK = 'tasks',
    DEAL = 'deals',
}
